/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Typography2 as Typography, breakpoints } from '@coursera/cds-core';

type Props = {
  imageUrl?: string | null;
  heading?: string | null;
  body?: string | null;
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    gap: var(--cds-spacing-300);

    ${breakpoints.down('xs')} {
      flex-direction: column;
    }
  `,
  image: css`
    flex-shrink: 0;
    position: relative;
    width: 144px;
    height: 144px;
    overflow: hidden;
    border-radius: 100%;

    > img {
      position: absolute;
      height: 100%;
      left: 50%;
      transform: translateX(-50%);
    }
  `,
  content: css`
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-200);
  `,
};

const RoleTestimonial = ({ imageUrl, heading, body }: Props) => {
  if (!heading && !body) return null;

  return (
    <div css={styles.container}>
      {imageUrl && (
        <div css={styles.image}>
          <Imgix
            alt={Imgix.DECORATIVE}
            src={imageUrl}
            imgParams={{ auto: 'format,compress', fit: 'fill', width: 145, height: 145 }}
          />
        </div>
      )}
      <div css={styles.content}>
        <Typography variant="subtitleLarge" component="h3">
          {heading}
        </Typography>
        <Typography variant="bodyPrimary" component="p" color="supportText">
          {body}
        </Typography>
      </div>
    </div>
  );
};

export default RoleTestimonial;
